'use client';

import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { Languages } from 'lucide-react';
import { usePathname, useRouter } from 'next/navigation';
import { i18n } from '@/i18n-config';

export function LanguageSwitcher() {
  const router = useRouter();
  const pathname = usePathname();

  const changeLocale = (locale: string) => {
    if (!pathname) return;
    const segments = pathname.split('/');
    // Check if the first segment is a locale
    if (i18n.locales.includes(segments[1] as any)) {
      segments[1] = locale;
    } else {
      // If no locale in path, add it. This might not be strictly necessary
      // if middleware always redirects, but good for robustness.
      segments.splice(1, 0, locale);
    }
    const newPath = segments.join('/');

    document.cookie = `NEXT_LOCALE=${locale}; path=/; max-age=31536000; SameSite=Lax`;
    router.push(newPath);
    // router.refresh(); // router.push should trigger a refresh
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" size="icon">
          <Languages className="h-[1.2rem] w-[1.2rem]" />
          <span className="sr-only">Change language</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem onClick={() => changeLocale('en')}>
          <div className="flex items-center gap-2">
            <span>🇺🇸</span>
            <span>English</span>
          </div>
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => changeLocale('es')}>
          <div className="flex items-center gap-2">
            <span>🇪🇸</span>
            <span>Español</span>
          </div>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
